
const Inicio = () => {
    return (
        <div className='w-full min-h-[calc(100vh-50px)]'></div>
    )
}
export default Inicio
